<template>
  <card>
    <template slot="header">
      <h4 class="card-title d-inline">{{ $t('accountDelete.deletingView.title') }}</h4>
    </template>
    <div v-loading="loading" v-if="account && accountDeletion">
      <div class="row p-0 m-0">
        <div class="col-auto">
          <account-deletion-details :details="accountDeletion"/>
        </div>
        <div class="col" v-if="$auth.can({account_delete: 'update'}, 'permissions')">
          <finalise-deleting-view/>
        </div>
      </div>
    </div>
  </card>
</template>
<script>
import {mapActions, mapState} from "vuex";
import AccountDeletionDetails from "src/components/AccountDeletion/AccountDeletionDetails";
import FinaliseDeletingView from './FinaliseDeletingView';

export default {
  name: "AccountDeletingView",
  components: {
    AccountDeletionDetails,
    FinaliseDeletingView,
  },
  props: {
    accountId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState({
      loading: state => state.account_deletion.loading,
      error: state => state.account_deletion.error,
      accountDeletion: state => state.account_deletion.data,
      account: state => state.account.data,
    }),
  },
  methods: {
    ...mapActions(['DeleteAccount', 'GetAccountDeletion']),
  },
  mounted() {
    this.GetAccountDeletion(this.accountId)
  },
}
;
</script>
